import _ from 'lodash';

const getTargetPage = (props, targetKey) => _.get(props, `${targetKey}.currentPage`, 1);

export const getInitialDashboardPage = (props, targetKey) => getTargetPage(props, targetKey);

export const getCurrentDashboardPage = (props, state, targetKey) => (
  _.get(state, 'page') || getTargetPage(props, targetKey)
);

export const syncDashboardPageFromProps = (component, nextProps, targetKey) => {
  const currentPage = getTargetPage(component.props, targetKey);
  const nextPage = getTargetPage(nextProps, targetKey);

  if (currentPage !== nextPage) {
    component.setState({ page: nextPage });
  }
};

export const refetchCurrentDashboardPage = (component, targetKey, propsOverride = null) => {
  const nextPage = propsOverride ? getTargetPage(propsOverride, targetKey) : null;
  const currentPage = nextPage || getCurrentDashboardPage(component.props, component.state, targetKey);

  component.fetch(currentPage);
};
